export const courses = [
  {
    level: "Beginner",
    duration: "4 weeks",
    description: "Absolute beginners looking to learn the basics of chess.",
    topics:["Chessboard and Piece Setup",
            "Basic Rules and Movements",
            "Check, Checkmate, and Stalemate",
            "Simple Opening Strategies"],
    material:["Illustrated PDFs",
              "Beginner-friendly practice puzzles",
              "Weekly quizzes"]
  },
  {
    level: "Intermediate",
    duration: "6 weeks",
    description: "Players familiar with basics aiming to improve gameplay.",
    topics:["Opening Principles and Variations",
            "Tactical Motifs: Forks, Pins",
            "Positional Play Basics",
            "Endgame Techniques"],
    material:["Video lessons",
              "Strategy Books(Digital)",
              "Personalized feedback on games"]
  },
  {
    level: "Advanced",
    duration: "8 weeks",
    description: "Advanced players sharpening competitive skills.",
    topics:["Advanced Opening Repertoires",
            "Dynamic Middlegame Plans",
            "Complex Endgame Scenarios",
            "Tournament Preparation Tips"],
    material:["Access to exclusive master-level games",
              "Live workshops with coaches",
              "Annotated games database"]
  },
];

export const tournaments = [
  {
    name: "Spring Championship",
    date: "April 23–25",
    description: "Join the intense battle for the championship title.",
  },
  {
    name: "Summer Showdown",
    date: "July 10–12",
    description: "Experience the ultimate showdown of top teams.",
  },
];

export const testimonials = [
  {
    name: "Vansh",
    rating: 5,
    text:
  "ChessWizzania helped me gain confidence and improve my rating. The lessons are easy to understand, and I now feel more comfortable planning my moves and handling tough positions."

  },
{
  name: "Parent of Avinash",
  rating: 5,
  text:
    "Very structured and professional coaching. The sessions are well planned and easy to follow. My child has shown clear improvement in understanding concepts and confidence while playing. He genuinely looks forward to every class.",
},

 {
  name: "Parent of Tanmay",
  rating: 5,
  text:
    "The coaching is highly structured and professional. Each session is thoughtfully planned and easy to understand. I’ve seen a noticeable improvement in my child’s conceptual clarity and confidence during games. He genuinely looks forward to every class.", 
}

];
